module.exports = __webpack_public_path__ + "static/media/thumb_BWYK1593_1024.7632c68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_BWYK1593_1024.jpg
// module id = 131
// module chunks = 0